import React, { useEffect, useState,useRef } from "react";
import BioIconSVG from "assets/svg/bio-icon";
import Button from "components/button/button";
import CalendarDayIconSVG from "assets/svg/calendar-day-icon";
import MapMarkerIconSVG from "assets/svg/map-marker-icon";
import TagIconSVG from "assets/svg/tag-icon";
import ChildHeadIconSVG from "assets/svg/child-head-icon";
import IDBadgeIconSVG from "assets/svg/id-badge-icon";
import { HiOutlinePencil } from "react-icons/hi";
import { FiCheck } from "react-icons/fi";
import TextArea from "components/textarea/textarea";
import toast from "react-hot-toast";
import LoadingIndicator from "assets/svg/loading-indicator";
import Input from "components/input/input";
import { CHILD, CIVIL_STATUS, removeUndefinedProperties, currentLang } from "utils/utils";
import { groupTypes } from "utils/constant";
import _ from "lodash";
import Select from "components/select/select";
import DatePicker from "components/datepicker/datepicker";
import moment from "moment";
import PopInfo from "components/info-popup/pop-info";
import { personalDateFormat, parseDateOnly } from "utils/utils";
import { useTranslation } from "react-i18next";
import Popup from "reactjs-popup";
import { FaEllipsisH  } from "react-icons/fa";
import { IoLanguageOutline } from "react-icons/io5";
import AutoCompleteAddress from "components/google-address/auto-complete";
import WYSIWYGEditor from "components/wysiwyg/wysiwyg";

const ICONS = {
  birthdate: <CalendarDayIconSVG className="m-auto" />,
  birth_location: <MapMarkerIconSVG className="m-auto" />,
  civil_status: <TagIconSVG className="m-auto" />,
  children: <ChildHeadIconSVG className="m-auto" />,
  other_name: <IDBadgeIconSVG className="m-auto" />,
};

export default function GroupTeam(props) {
  
  const {t} = useTranslation();
  const lang = currentLang();
  const buttonProps = {
  edit: {
    btnName: t("edit"),
    icon: <HiOutlinePencil />,
    btnClass: "relative px-6 py-2 bg-white hover:bg-gray hover:rounded-b-md justify-start w-full",
    btnTextClass:"text-lg  flex flex-row items-center gap-2",
  },
  save: {
    btnName: t("saveChanges"),
    icon: <FiCheck className="text-lg" />,
    btnClass: "relative py-3.6 px-5.5 bg-primary hover:bg-darkPrimary",
    btnTextClass:
      "text-sm text-white font-semibold flex items-center space-x-1.6",
  },
};

  // console.log("==============================");
  // console.log(props.profile);
  const { profile, userData, setUserData } = props;
  const { http, localstorage } = global.services;
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({});
  const [personal, setPersonal] = useState([]);
  const optionRef = useRef();
  const [loadingTranslate , setTransLoad] = useState(false);
  const [showMoreOption, setShowMoreOption] = useState();
  
  useEffect(() => {
      window.addEventListener(
          "scroll",
          () => {  
              if (optionRef.current) {
                  optionRef.current.close();
              }
          },
          true
      );
      return () => {
          window.removeEventListener("scroll", () => {});
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
 

  useEffect(() => {
    console.log("update dire")
    if (!_.isEmpty(profile)) {
      console.log("profile", profile?.profile_type?.type);
      console.log(t(profile?.profile_type?.type));
      let description = profile.bio;
      if (!_.isEmpty(profile.mention_bio)) {
        Object.keys(profile.mention_bio).forEach((k) => {
          const pUsername = profile.mention_bio[k]?.p_username;
          // Regex to match href containing username and capture the name between <a> and </a>
          const regex = new RegExp(`(<a[^>]*key="[^"]*${pUsername}[^"]*"[^>]*>)(.*?)(<\/a>)`, 'g');
          
          description = description.replace(regex, (match, openingTag, name, closingTag) => {
            return `${openingTag}@${pUsername}${closingTag}`;
          });
        });
      }
      setState({
        bio: description,
        birthdate: parseDateOnly(profile?.birthdate),
        formation_date: profile?.formation_date,
        birth_location: profile?.birth_location,
        civil_status: profile?.civil_status,
        children: profile?.children,
        other_name: profile?.other_name,
      });
      setPersonal([
        [
          {
            label: t('dateFormation'),
            value: profile?.formation_date,
            icon: ICONS.birthdate,
            form: "input",
            formProps: {
              name: "formation_date",
            },
          },
          {
            label: t("formationLocation"),
            value: profile?.birth_location,
            icon: ICONS.birth_location,
            form: "address",
            formProps: {
              name: "birth_location",
            },
          },
        ],
      ]);
    }
  }, [profile]);
  //=============================functions ======================================
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log("loader")
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleBioChange = React.useCallback((val) => {
    setState(prev => {
      if (prev.bio === val) return prev;
      return { ...prev, bio: val };
    });
  }, []);

  const onClickSave = async () => {
    try {
      setLoading(true);
      const payload = removeUndefinedProperties(state);
      if (!_.isEmpty(payload)) {
        if (payload.birthdate) {
          // Send the birthdate as a plain calendar date (local Y-M-D) so it is
          // stored exactly as picked. The previous "+8 hours" hack shifted the
          // day depending on the user's timezone/save time (off-by-one bug).
          payload.birthdate = moment(payload.birthdate).format("YYYY-MM-DD");
        }
        const { data } = await http.put(
          `public/profiles/update-personal-information/${profile?.id}`,
          payload
        );
        if (data) {
          updateProfile(data)
          toast.success(t('personalInformationSuccessfully'));
        }
      }
    } catch (error) {
      toast.error(
        error?.data?.message || t('somethingWentWrong')
      );
      setLoading(false);
      setEdit(false);
    } finally {
      setLoading(false);
      setEdit(false);
    }
  };

  const displayValue = (name, value) => {
    if (name === "children") {
      if (value) {
        return `${value} Children`;
      } else {
        return "--";
      }
    } else if (name === "birthdate") {
      if (value) {
        return personalDateFormat(value, profile?.dateFormat);
      } else {
        return "--";
      }
    } else {
      return (profile?.translation?.[lang]?.[value] || value) || '--';
    }
  };

  const translateGroupInfo = async()=>{
    if (userData?.profile?.id === profile?.id) {
        try{
            setTransLoad(true)
            let curLang = localStorage.getItem('lang');
            const { data } = await http.put(`public/profile/${profile?.id}/translate-personal-info`,{
                lang:curLang
            }); 
            if(data.data){
                updateProfile(data)
                toast.success(t('completedTranslate'))
            }else{
                toast.success(t('beenTranslated'));
            }
            setTransLoad(false)
        }catch(e){
            setTransLoad(false)
            toast.error(t('somethingWentWrong'));
        }
    }
  }

  const updateProfile = (data)=>{  
        const resultValue = data.data;
        setPersonal([
          [
            {
              label: t('dateFormation'),
              value: resultValue.formation_date,
              icon: ICONS.birthdate,
              form: "input",
              formProps: {
                name: "formation_date",
              },
            },
            {
              label: t("birthFormation"),
              value: resultValue.birth_location,
              icon: ICONS.birth_location,
              form: "input",
              formProps: {
                name: "birth_location",
              },
            },
          ],
        ]);
        //set userdata and update localstorange
        // console.log("resultValue", resultValue);
        const updatedData = { ...userData, profile: resultValue };
        setUserData(updatedData);
        localstorage.set("user_data", JSON.stringify(updatedData));
        typeof props.onDoneUpdate === 'function' && props.onDoneUpdate(updatedData);
        setLoading(false);
        setEdit(false);
  }
//   useEffect(() => {
//   const handleKeyDown = (e) => {
//     if (e.key === "Enter" && edit) {
//       onClickSave()
//     }
//   };

//   window.addEventListener("keydown", handleKeyDown);

//   return () => {
//     window.removeEventListener("keydown", handleKeyDown);
//   };
// }, [edit, onClickSave, state]);

  return (
    <div className="w-full bg-white rounded-md px-5 2md:pl-29 2md:pr-24.5 py-10 md:pb-14 md:pt-8">
      <div className="w-full flex justify-between flex-wrap items-center mb-8 ">
        <div className="flex flex-row gap-x-2 items-center">
          <h1 className="text-2xl font-semibold text-lightBlack">
            <span className="capitalize">{t(profile?.profile_type?.type) || profile?.profile_type?.type}</span>{" "}
              {t('information')}
          </h1>
          <PopInfo containerClass="relative" type={`${profile?.profile_type?.type}_information`} />
        </div>
        {props.isYourProfile && (
          <>
          {
            edit ?
            <Button
              buttonName={
                edit ? buttonProps.save.btnName : buttonProps.edit.btnName
              }
              buttonTextClass={
                edit
                  ? buttonProps.save.btnTextClass
                  : buttonProps.edit.btnTextClass
              }
              iconPosition="left"
              icon={edit ? buttonProps.save.icon : buttonProps.edit.icon}
              buttonRadius="6px"
              buttonClass={
                edit ? buttonProps.save.btnClass : buttonProps.edit.btnClass
              }
              loadingIcon={
                loading ? (
                  <LoadingIndicator className="text-white w-4 h-4" />
                ) : null
              }
              disabled={loading}
              onClick={() => {
                if (edit) {
                  onClickSave();
                } else {
                  setEdit((prev) => !prev);
                }
              }}
          />:
          <Popup
                ref={optionRef}
                position="bottom right"
                open={showMoreOption}
                onClose={() => setShowMoreOption(false)}
                arrow={false}
                contentStyle={{ marginTop: 10, marginLeft: 5 }}
                trigger={
                    <button
                        className="py-0 bg-thBg rounded-md 3md:py-4 3md:px-5 px-3"
                        onClick={() =>
                            setShowMoreOption((open) => !open)
                        }
                    >
                        <FaEllipsisH className="p-0 m-0" />
                    </button>
                }
              >
                <div className="flex flex-col shadow-lg rounded-md bg-white">
                    <ul className="w-full">
                        <li className="hover:bg-gray hover:rounded-md">
                            <Button
                              buttonName={
                                edit ? buttonProps.save.btnName : buttonProps.edit.btnName
                              }
                              buttonTextClass={
                                edit
                                  ? buttonProps.save.btnTextClass
                                  : buttonProps.edit.btnTextClass
                              }
                              iconPosition="left"
                              icon={edit ? buttonProps.save.icon : buttonProps.edit.icon}
                              buttonRadius="6px"
                              buttonClass={
                                edit ? buttonProps.save.btnClass : buttonProps.edit.btnClass
                              }
                              loadingIcon={
                                loading ? (
                                  <LoadingIndicator className="text-white w-4 h-4" />
                                ) : null
                              }
                              disabled={loading}
                              onClick={() => {
                                if (edit) {
                                  onClickSave();
                                } else {
                                  setEdit((prev) => !prev);
                                }
                              }}
                            />
                        </li>
                        <li>
                            <Button
                                disabled={loadingTranslate}
                                buttonName={
                                    <div className="flex gap-2 items-center">
                                        <IoLanguageOutline/>
                                        <div>{t('translate')}</div>
                                    </div> 
                                }
                                buttonTextClass="text-lg  flex flex-row items-center gap-2"
                                buttonRadius="6px"
                                icon={
                                loadingTranslate ? (
                                    <LoadingIndicator className="text-primary w-4 h-4" />
                                ) : null
                                }
                                buttonClass="relative px-6 py-2 bg-white hover:bg-gray hover:rounded-b-md justify-start w-full"
                                onClick={translateGroupInfo}
                            />
                        </li>                     
                    </ul>
                </div>
          </Popup> 
          }
          </>
          
        )}
      </div>
      <div className="w-full grid gap-y-12 max-w-screen-2smd">
        {/* ==================== BIO =================================== */}
        <div className="w-full">
          <div
            className={`${
              props.isYourProfile
                ? "w-full flex flex-start items-start space-x-6"
                : profile?.bio
                ? "w-full flex flex-start items-start space-x-6"
                : "hidden"
            }`}>
            <div className="w-15 h-15 rounded-full bg-bGray grid">
              <BioIconSVG className="m-auto" />
            </div>
            <div style={{ width: "calc(100% - 60px)" }}>
              <h3 className="text-xl text-lightBlack font-semibold">{t('bio')}</h3>
              {edit ? (
                <WYSIWYGEditor
                    optional={false}
                    value={state.bio}
                    limitChar={2000}
                    onChange={handleBioChange}
                    preserveWhitespace={true}
                    minimalToolBar={true}
                  />
              ) : (
                <p className="text-base leading-6.7 tracking-tightest text-darkerGray mt-1.5 whitespace-pre-line">
                  {/* {profile?.translation?.[lang]?.bio || profile?.bio || "--"} */}
                  <div dangerouslySetInnerHTML={{ __html: profile?.translation?.[lang]?.bio || profile?.bio || "--" }}>
                    </div>
                </p>
              )}
            </div>
          </div>
        </div>
        {/* ===================== Divider ============================================ */}
        <hr className="text-gray" />
        {/* ==================== OTHER INFORMATION =================================== */}
        <div className="w-full">
          <div className="w-full grid gap-y-12">
            {(personal || []).map((parent, index) => {
              return (
                <div
                  className="w-full space-y-4.5 4sm:flex 4sm:flex-start 4sm:space-x-4.5 4sm:space-y-0"
                  key={index}>
                  {(parent || []).map((obj, subIndex) => {
                    if (props.isYourProfile || obj?.value) {
                      return (
                        <div
                          className="w-full flex flex-start items-start space-x-6"
                          key={subIndex}>
                          <div className="w-15 h-15 rounded-full bg-bGray grid">
                            {obj.icon}
                          </div>
                          <div style={{ width: "calc(100% - 60px)" }}>
                            <h3 className="text-xl text-lightBlack font-semibold">
                              {obj.label}
                            </h3>
                            {edit ? (
                              <div className="w-full mt-3">
                                <FormBuilder
                                  type={obj.form}
                                  name={obj.formProps.name}
                                  placeholder={obj.label}
                                  onChange={handleInputChange}
                                  defaultValue={obj.value}
                                  state={state}
                                />
                              </div>
                            ) : (
                              <p className="text-base leading-6.7 tracking-tightest text-darkerGray mt-1.5">
                                {displayValue(obj.formProps.name, obj.value)}
                              </p>
                            )}
                          </div>
                        </div>
                      );
                    } else {
                      return null;
                    }
                  })}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

function FormBuilder(props) {
  const { type, name, placeholder, onChange, defaultValue, state } = props;
  let options = CIVIL_STATUS;
  let selectDefaultValue = { label: defaultValue, value: defaultValue };
  if (name === "children") {
    options = CHILD;
    let valueObject = _.find(CHILD, { value: defaultValue });
    selectDefaultValue = valueObject;
  }
  if (type === "input") {
    return (
      <Input
        inputContainerClass="w-full"
        defaultValue={defaultValue}
        name={name}
        placeholder={placeholder}
        outsideLabelClass="text-sm font-bold text-darkerGray"
        noLabelPaddingY="1rem"
        type="text"
        onChange={onChange}
      />
    );
  } else if (type === "select") {
    return (
      <Select
        formContainer="w-full"
        options={options}
        placeholder={placeholder}
        name={name}
        defaultValue={selectDefaultValue || null}
        height={58}
        onChange={(e) => onChange({ target: { name: name, value: e.value } })}
      />
    );
  } else if (type === "datepicker") {
    return (
      <DatePicker
        formContainer="w-full"
        icon="noLabel"
        selected={state[name] ? new Date(state[name]) : null}
        onChange={(date) =>
          onChange({ target: { name: name, value: new Date(date) } })
        }
        placeholderText={placeholder}
      />
    );
  }
  else if (type === "address"){
    return <AutoCompleteAddress
      key={1}
      name={name}
      value={state[name]}
      onChange={(name,value) => onChange({ target: { name: name, value: value } })}
      placeholder="Melbourne VIC, Australia"
      placeTypes={[]}
    />
  }
  return <></>;
}
